// extracted by mini-css-extract-plugin
export default {"productCarousel":"V1-z"};